import {TypographyOptions} from '@material-ui/core/styles/createTypography';
import * as colors from 'assets/theme/colors';

export const typography: TypographyOptions = {
    fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
        fontWeight: 'lighter',
        fontSize: 64,
        lineHeight: '72px',
        color: colors.secondary.A01,
        letterSpacing: '0.25px',
    },
    h2: {
        fontWeight: 'lighter',
        fontSize: 48,
        lineHeight: '56px',
        color: colors.secondary.A01,
        letterSpacing: '0.25px',
    },
    h3: {
        fontWeight: 'normal',
        fontSize: 32,
        color: colors.secondary.A01,
        lineHeight: '40px',
    },
    h4: {
        fontWeight: 'normal',
        fontSize: 24,
        lineHeight: '32px',
        color: colors.secondary.A01,
        letterSpacing: '0.15px',
    },
    h5: {
        fontWeight: 'normal',
        fontSize: 20,
        lineHeight: '32px',
        color: colors.secondary.A01,
        letterSpacing: '0.15px',
    },
    // body
    body1: {
        fontWeight: 'lighter',
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: '0.1px',
    },
    // body small
    body2: {
        fontWeight: 'lighter',
        fontSize: 14,
        lineHeight: '16px',
        letterSpacing: '0.5px',
    },
    subtitle1: {
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: '0.25px',
    },
    subtitle2: {
        fontSize: 14,
        textTransform: 'capitalize',
    },
    button: {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: '24px',
        textTransform: 'uppercase',
        letterSpacing: '0.1px',
    },
    caption: {
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.25px',
    },
};
